import { InspectionStatusData } from './inspection-status-data';
import { ContractContactData } from './contract-contact-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class ContractData {
  ContractId: string;
  ContractTypeId: string;
  ContractType: string;
  ContractName: string;
  Description: string;
  CustomerId: string;
  ContractReference: string;
  ContractStatusId: string;
  SiteId: string;
  IsPrincipalContract: boolean;
  IsCustomerNotPresent: boolean;
  IsScheduleRatesAgreed: boolean;
  CanSubmitDocumentsWithoutSignature: boolean;
  CreationDate: string;
  InspectionStatus: InspectionStatusData;
  ContractContacts: { [key: string]: ContractContactData };
  HasScaffolds: boolean;
  IsCameraAllowed: boolean;
  AllowDismantleWithoutOffhire: boolean;
  Deleted: boolean;
  LastModified: string;
}


